import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function Toaster({ showAlert }: any) {
  const [open, setOpen] = React.useState(false);

  useEffect(()=>{
    if(!!showAlert.message) {
      setOpen(true)
    }
  }, [showAlert])

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={showAlert.type} sx={{ width: '100%' }}>
          {showAlert.message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}